import client from "../client"

export const getMotibellLanding = async ({ motibellNo }) => {
  const response = await client.get(`/motibells/${motibellNo}/landing`)

  return response.data
}
